import { ActionUnionTypes } from 'reduxStore/actionCreator';
import { INIT_STRIPE_REQUEST_SUCCESS, CLEAR_STRIPE } from 'reduxStore/actionsConst';
import * as stripeActions from './actions';

export interface StripeReducer {
  idealPaymentInProgress: boolean;
  stripePublicApiKey?: string;
}

export const initialState: StripeReducer = {
  idealPaymentInProgress: false,
};

export const stripeReducer = (
  state = initialState,
  action: ActionUnionTypes<typeof stripeActions>,
): StripeReducer => {
  switch (action.type) {
    case CLEAR_STRIPE:
      return initialState;
    case INIT_STRIPE_REQUEST_SUCCESS:
      return {
        ...initialState,
        ...action.payload,
      };
    default:
      return state;
  }
};
